<template>
    <div class="real-name-box">
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input placeholder="请输入内容" v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="用户名" :value="2"></el-option>
                            <el-option label="手机号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.source" placeholder="请选择" size="small">
                        <el-option label="不限制用户来源渠道" value=""></el-option>
                        <el-option v-for="(item,index) in sourceList" :key="index" :label="`仅看来源于${item.name}的`" :value="item.id"></el-option>
                        <!-- <el-option label="仅看来源于网易云音乐的" :value="12"></el-option>
                        <el-option label="仅看来源于大麦的" :value="15"></el-option>
                        <el-option label="仅看来源于秀动赠票的" :value="16"></el-option>
                        <el-option label="仅看来源于QQ音乐的" :value="13"></el-option>
                        <el-option label="仅看来源于文客的" :value="14"></el-option>
                        <el-option label="仅看来源于糯米的" :value="10"></el-option> -->
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="不限制用户注册终端" value=""></el-option>
                        <el-option label="仅看通过iOS注册的" :value="3"></el-option>
                        <el-option label="仅看通过Android注册的" :value="4"></el-option>
                        <el-option label="仅看通过WAPCN站注册的" :value="2"></el-option>
                        <el-option label="仅看通过WAPEN站注册的" :value="5"></el-option>
                        <el-option label="仅看通过WEB站注册的" :value="1"></el-option>
                        <el-option label="仅看通过微信小程序注册的" :value="6"></el-option>
                        <el-option label="仅看通过抖音小程序注册的" :value="7"></el-option>
						<el-option label="仅看通过支付宝小程序注册的" :value="12"></el-option>
                        <el-option label="仅看通过小红书小程序注册的" :value="13"></el-option>
                        <el-option label="仅看通过鸿蒙注册的" :value="14"></el-option>
                        <el-option label="仅看通过管理后台注册的" :value="9"></el-option>
                        <el-option label="仅看通过经营平台注册的" :value="10"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制账号状态" value=""></el-option>
                        <el-option label="仅看正常的" :value="1"></el-option>
                        <el-option label="仅看注销的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.order" placeholder="请选择" size="small">
                        <el-option label="优先展示最新注册的" :value="1"></el-option>
                        <el-option label="优先展示最近登录的" :value="2"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input placeholder="请输入内容" v-model="params.level" class="input-with-select" size="small">
				        <el-select v-model="level" slot="prepend" placeholder="请选择">
				            <el-option label="用户等级" :value="1"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.creditLevel" placeholder="请选择" size="small">
						<el-option label="不限制信用等级" :value="-1"></el-option>
				        <el-option label="T0" :value="0"></el-option>
						<el-option label="T1" :value="1"></el-option>
						<el-option label="T2" :value="2"></el-option>
						<el-option label="T3" :value="3"></el-option>
						<el-option label="T4" :value="4"></el-option>
				        <el-option label="T5" :value="5"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="注册时间" :value="1"></el-option>
                                <el-option label="最近登录时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button v-if="$utils.have('/fans/manger/list')"  type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button v-if="$utils.have('/fans/manger/list')" type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportVisible = true"
                v-if="$utils.have('/fans/manger/createExport')"
                size="small"
                >导出乐迷</el-button>
            
			<el-button
			    type="primary"			    
			    v-if="$utils.have('/nicknameDisabled/list')"
			    size="small"
				@click="nicknameList"
			    >禁用昵称</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="账号状态">
                    <template slot-scope="scope">
                        {{scope.row.status != undefined && accountStatus.get(scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column label="禁言状态">
                    <template slot-scope="scope">
                        {{scope.row.slienceType != undefined && slienceTypeMap.get(scope.row.slienceType)}}
                    </template>
                </el-table-column>
                <el-table-column label="ID" prop="id"></el-table-column>
                <el-table-column label="用户名" prop="name" show-overflow-tooltip min-width="100"></el-table-column>
				<el-table-column label="用户等级" prop="level"></el-table-column>
				<el-table-column label="信用等级" prop="creditLevel"></el-table-column>
                <el-table-column label="手机区号" prop="areaCode"></el-table-column>
                <el-table-column label="手机号码" prop="telephone" min-width="100"></el-table-column>
                <el-table-column label="来源渠道" prop="sourceName" min-width="90"></el-table-column>
                <el-table-column label="注册终端">
                    <template slot-scope="scope">
                        {{scope.row.terminal && terminalMap.get(scope.row.terminal)}}
                    </template>
                </el-table-column>
                <el-table-column label="注册时间" prop="registTime" min-width="150"></el-table-column>
                <el-table-column label="最近登录时间" prop="lastLoginTime" min-width="150"></el-table-column>                
                <el-table-column fixed="right" label="操作" width="150" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/fans/manger/detail')"
                            icon="el-icon-s-management"
                            @click="edit(scope.row.id)"
                            >管理</el-button>
                        <!-- <el-button
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="toOrderList(scope.row.id)"
                            >查看订单</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <detail :detailVisible.sync="detailVisible" :detailId="detailId"/>
        <export :exportVisible.sync="exportVisible"/>
		
    </div>
</template>
<script>
import Detail from './components/detail';
import Export from './components/export';

import {dataMap} from './components/mixins';
const defaultParams = {
    pageNo: 1,
    type: 1,
    value: '',
    timeType: 1,
    startTime: '',
    endTime: '',
    source: '',
    terminal: '',
    status: '',
    order: 1,
	level:'',
	creditLevel:-1
}
export default {
    mixins: [dataMap],
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                type: parseInt(this.$route.query.type || 1),
                value: this.$route.query.value || "",
                timeType: parseInt(this.$route.query.timeType || 1),
                startTime: this.$route.query.startTime || "",
                endTime: this.$route.query.endTime || "",
                source: this.$route.query.source ? parseInt(this.$route.query.source) : "",
                terminal:  this.$route.query.terminal ? parseInt(this.$route.query.terminal) : "",
                status: this.$route.query.status ? parseInt(this.$route.query.status) : "",
                order: parseInt(this.$route.query.order || 1),
				level: this.$route.query.level ? parseInt(this.$route.query.level) : "",
				creditLevel: parseInt(this.$route.query.creditLevel || -1),
            },
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            listLoading: false,
            detailVisible: false,
			mergeVisible: false,
            detailId: null,
            exportVisible: false,
            sourceList:[],
			level:1
        };
    },
    components: {
        Detail,
        Export
		
    },
    computed: {
        accountStatus(){
            return new Map([
                [1, '正常'],
                [0, '注销']
            ])
        },
        slienceTypeMap(){
            return new Map([
                [1, '禁言'],
                [0, '正常']
            ])
        }        
    },
    created(){
        if(this.$route.query.userId) this.params.value = this.$route.query.userId;
        this.getSourceList();
        this.getDataList();
    },
    methods: {
        //获取用户来源渠道
        getSourceList(){
            if(this.$utils.have('/fans/manger/sourceList')){
                this.$request({
                    url: "/fans/manger/sourceList",
                    method: "POST",
                })
                    .then((res) => {
                        const { state, msg, result } = res.data;
                        if (state == 1 && result) {
                            this.sourceList = result;
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .finally(() => {
                    });
            }
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/fans/manger/list",
                method: "POST",
                data:this.params
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        const data = result.result || [];
                        data.forEach(item=> {
                            item.areaCode = item.areaCode.split('_')[0];
                            item.telephone = this.initTelnumber(item.telephone)
                        })
                        this.dataList = result.result;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
		//乐迷详情
		edit(id) {
		    this.$router.push({
		        path: `/user/fans/edit/${id}`,
		        query: {
		            redirect: this.$utils.objArgs(
		                this.$router.currentRoute.path,
		                this.params
		            ),
		        },
		    });
		}, 
		//禁用昵称
		nicknameList(){
		    this.$router.push('/user/fans/nickname');
		},
        // 跳转订单页面
        toOrderList(id){
            this.$router.push({
                path: '/activityManage/order/list', 
                query: {
                    searchType:5,
                    searchValue:id,
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            })
        },
        // 手机号码打码处理
        initTelnumber(number){
            if(!number) return
            if(number.length<5) return number
            let len = number.length,  range = 4;
            if(len == 7 || len == 8){
                range = 3
            }else if(len == 5 || len == 6){
                range = 2
            }
            let reg = new RegExp(`(\\w+)(\\w{${range}})(\\w{${range}})$`)
            let str = '*'.repeat(range);
            return number.replace(reg, `$1${str}$3`)
        }
    }
};
</script>
<style scoped lang="scss">
</style>
